module.exports = __webpack_public_path__ + "img/cafecentral.14b7a4ad.png";